import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useNavigate, useRouterState } from '@tanstack/react-router'
import { upsertHashToken } from '@services/router/hashTokens'
import { newCalendarEventHashToken } from '@features/calendar/components/NewEventRouteModal'

export const Route = createFileRoute('/_layout/calendar/events/new')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'New',
        }
    }
})

function RouteComponent() {
	const navigate = useNavigate()
	const hash = useRouterState({ select: (state) => state.location.hash ?? '' })

	useEffect(() => {
		navigate({
			to: '/calendar',
			hash: upsertHashToken(hash, newCalendarEventHashToken),
			replace: true,
			hashScrollIntoView: false,
		})
	}, [hash, navigate])

	return null
}
